




import Vue from 'vue'
import Component from 'vue-class-component'
import ResidentHistory from '@/views/app/management/residents/resident-page/components/ResidentHistory.vue'

@Component({
  components: { ResidentHistory }
})
export default class ResidentHistoryTab extends Vue {
}
